import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderHistoryRoutingModule } from './order-history-routing.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { RestaurantSelectionModule } from '../restaurant-selection/restaurant-selection.module';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    OrderHistoryRoutingModule,
    SharedModule,
    RestaurantSelectionModule
  ]
})
export class OrderHistoryModule { }
